import React from "react";
import { Button, Modal } from "react-bootstrap";
import "../JoinScheduledEvent.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { SkillSearchInput } from "../../../../_uiComponents/Search/SkillSearchInput";
function HmsQuestionModal({
  modalOpen,
  handleModalOpen,
  onHmsQuestionFormChange,
  hmsQuestionForm,
  onHmsQuestionCreateClick,
  skills,
}) {
  return (
    <Modal
      size="xl"
      show={modalOpen}
      onHide={handleModalOpen}
      className="border-0 common-modal mt-5"
    >
      <Modal.Header className="bg-grey align-items-center">
        <Modal.Title className="text-uppercase">
          <h3 className="mb-0">Interview Quesions</h3>
        </Modal.Title>
        <FontAwesomeIcon
          icon={faXmark}
          className="fa-2x cursor-pointer"
          onClick={handleModalOpen}
        />
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="bg-white py-3 border-6 shadow-sm ">
          <div className="container">
            <div className="py-1 form-group">
              <p className="font-weight-medium">
                <span className="text-danger">*</span>Interview Questions
              </p>
              <div className="form-group">
                <input
                  className="form-control bg-transparent"
                  type="text"
                  placeholder="Enter your question here"
                  name="question"
                  onChange={onHmsQuestionFormChange}
                  defaultValue={hmsQuestionForm?.question}
                />
              </div>

              <SkillSearchInput
                className="form-control mw-100"
                placeholder="Search Skill..."
                onSearchSelect={(item) => onHmsQuestionFormChange(item, true)}
                clearSearch={true}
              />
              <div className="d-flex flex-wrap align-items-center">
                {skills &&
                  Array.isArray(skills) &&
                  skills.map((tag, index) => (
                    <div
                      className="h4 bg-grey-3 py-1 rounded font-weight-normal text-dark px-2 mr-2 text-capitalize mt-3"
                      key={index}
                    >
                      {tag}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex align-items-center justify-content-end">
          <Button variant="dark" onClick={handleModalOpen} className="ml-2">
            Cancel
          </Button>
          <button
            className="btn btn-primary ml-4"
            onClick={onHmsQuestionCreateClick}
          >
            Add
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default HmsQuestionModal;
